import { useQuery } from "@apollo/client";
import { Box, Button, Center } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useHitlFilters } from "..";
import { ActionLabel } from "../../../components/actionLabel/ActionLabel";
import { UrlCard } from "./UrlCard";
import {
  GET_REVIEWED_URLS_LIST_PAGINATION,
} from "../../../graphql/operations/campaignOperations/operations";
import { ComponentLoading } from "../../../components/loading/ComponentLoading";
import { ReviewedUrlTypeConnection } from "../../../graphql/generated";
import { GET_URL_LIST } from "../../../graphqlExternal/operations/operations";
import { UrlListPaginatedType } from "../../../graphqlExternal/generated";
import { CardList } from "../../../components/containers/cardList/CardList";
import { ReviewTypeEnum } from "../Header";


export const UrlList = () => {
  const hitlFilters = useHitlFilters();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [shouldRunQuery, setShouldRunQuery] = useState(
    hitlFilters.urlList.length > 0 ? false : true
  )
  // const location = useLocation();
  // const locationKey = location.key


  const partialListOfUrls: string[] = hitlFilters.urlList.slice(
    0,
    hitlFilters.urlLimit
  );

  // onCompletion function sets urlList limits and url list (initial load and for fetchMore) when filter is not all
  const onCompletionPredictionsCorrections = (
    data: ReviewedUrlTypeConnection,
    onCompletionType: "COMPLETION" | "UPDATE"
  ) => {
    let urlList: string[] = [];
    if (hitlFilters.correctionsFilter.value === ReviewTypeEnum.Corrections) {
      urlList = data.edges.map((url: any) => url.node.url);
    } 
    // else if (hitlFilters.correctionsFilter.value === ReviewTypeEnum.Predictions) {
    //   urlList = data.edges.map((url: any) => url.node.predictedFrom);
    // }
    if (onCompletionType === "COMPLETION") {
      hitlFilters.setUrlList(urlList);
      hitlFilters.setTotalListCount(data.totalCount);

      // if (urlList.length <= 15) {
      //   hitlFilters.setUrlLimit(urlList.length);
      // }
    } else if (onCompletionType === "UPDATE") {
      hitlFilters.setUrlList((prev: any) => [...prev, ...urlList]);
    }

    if (!data.pageInfo.hasNextPage) {
      hitlFilters.setEndOfPages(true);
    } else {
      hitlFilters.setEndOfPages(false);
    }
    setButtonLoading(false);
  };
  // onCompletion function sets urlList limits, cursor and url list (initial load and for fetchMore)
  const onCompletionAll = (
    data: UrlListPaginatedType,
    onCompletionType: "COMPLETION" | "UPDATE"
  ) => {
    const urlList = data.urlList.map((url) => url.pageUrl);
    if (onCompletionType === "COMPLETION") {

      hitlFilters.setUrlList(urlList);
      // hitlFilters.setCursor(data.cursor);

      // if (data.urls.length <= 15) {
      //   hitlFilters.setUrlLimit(data.urls.length);
      // }
    } else if (onCompletionType === "UPDATE") {
      // hitlFilters.setUrlList((prev: any) => [...prev, ...data.urls]);
      // hitlFilters.setCursor(data.cursor);
      hitlFilters.setUrlList((prev: any) => [...prev, ...urlList]);
    }

    hitlFilters.setEndOfPages(!data.hasNextPage);

    setButtonLoading(false);
  };

  // Handle filter change  to use appropriate query and on completion method
  const handleQuery = () => {
    let detailQuery = GET_URL_LIST;
    let onCompleted: (data: any) => void;

    switch (hitlFilters.correctionsFilter.value) {
      case ReviewTypeEnum.All:
        detailQuery = GET_URL_LIST;
        onCompleted = (data) => {
          onCompletionAll(data.urlList, "COMPLETION");
        };
        break;
      case ReviewTypeEnum.Corrections:
        detailQuery = GET_REVIEWED_URLS_LIST_PAGINATION;
        onCompleted = (data) => {
          const newData = data.reviewedUrlsListPaginated;
          onCompletionPredictionsCorrections(newData, "COMPLETION");
        };
        break;
      // case ReviewTypeEnum.Predictions:
      //   detailQuery = GET_PREDICTIVE_CORRECTIONS_LIST_PAGINATION;
      //   onCompleted = (data) => {
      //     const newData = data.predictiveCorrectionsListPaginated;
      //     onCompletionPredictionsCorrections(newData, "COMPLETION");
      //   };
      //   break;
      default:
        detailQuery = GET_URL_LIST;
        onCompleted = (data) => {
          onCompletionAll(data.urlList, "COMPLETION");
        };
        break;
    }

    return { detailQuery, onCompleted };
  };

  const { detailQuery, onCompleted } = handleQuery();


  const {
    error,
    loading,
    fetchMore,
  } = useQuery(detailQuery, {
    // Conditionally render context when the filter is set to ALL
    ...(hitlFilters.correctionsFilter.value === ReviewTypeEnum.All && {
      context: { clientName: "illumaDbEndpoint", type: "graphql" },
    }),
    skip: !shouldRunQuery,
    variables: {
      ...(hitlFilters.correctionsFilter.value === ReviewTypeEnum.All
          && {
            publisher: hitlFilters.publisherFilter.value,
            range: hitlFilters.dateRangeFilter.value,
            startDate: hitlFilters.startDateFilter,
            endDate: hitlFilters.endDateFilter,
          }),
      ...(hitlFilters.correctionsFilter.value === ReviewTypeEnum.Corrections
        && {
          publisher: hitlFilters.publisherFilter.value,
          dateRange: hitlFilters.dateRangeFilter.value,
          filterStartDate: hitlFilters.startDateFilter,
          filterEndDate: hitlFilters.endDateFilter,
        }),
      first: 15,
      offset: 0,
      search: hitlFilters.urlSearch,
      category:
        hitlFilters.categoryFilter.value === ReviewTypeEnum.All
          ? ""
          : hitlFilters.categoryFilter.value,
    },
    onCompleted,
    fetchPolicy: "no-cache"
  });


 // prevents correction/ preditions from re-querying when returning to url list page
  useEffect(() => {
    setShouldRunQuery(true);
  }, [hitlFilters.correctionsFilter, hitlFilters.categoryFilter]);

  // Currently not in use
  // navigate to previous position on page
  // useLayoutEffect(() => {
  //   if (!loading) {
  //     const timer = setTimeout(() => {
  //       const element = document.getElementById(`url-card-${hitlFilters.urlIndex}`);
  //       element?.scrollIntoView({behavior: 'smooth', block: 'center'})
  //     }, 1000)

  //     return () => clearTimeout(timer)
  //   }

  // },[loading, originalData, locationKey])

  if (loading) {
    return <ComponentLoading text={"Loading URLs..."} />;
  }
  if (error) {
    return <>Error</>;
  }

  return (
    <>
      {hitlFilters.urlList.length > 15 && (
        <Box>
          {hitlFilters.correctionsFilter.value !== ReviewTypeEnum.All && (
            <ActionLabel
              label={`Results: ${hitlFilters.totalListCount} urls found.`}
            />
          )}
        </Box>
      )}
      <CardList>
      {partialListOfUrls.map((url, ix) => (
        <UrlCard key={ix} url={url} urlIndex={ix}  />
      ))}
      </CardList>

      <Center
        margin={"6px"}
        color={"muted"}
        // hidden={hitlFilters.isMoreUrlsButtonDisabled}
      >
        {hitlFilters.endOfPages ? (
          "NO URLS FOUND"
        ) : (
          <Button

            isLoading={buttonLoading}
            isDisabled={hitlFilters.endOfPages}
            onClick={() => {
              setButtonLoading(true);
              // fetchmore urls for corrections/ predictions
              if (hitlFilters.correctionsFilter.value !== ReviewTypeEnum.All) {
                fetchMore({
                  variables: {
                    first: 15,
                    offset: hitlFilters.urlList.length,
                    search: hitlFilters.urlSearch,
                    category:
                      hitlFilters.categoryFilter.value === ReviewTypeEnum.All
                        ? ""
                        : hitlFilters.categoryFilter.value,
                  },
                  // updates previous result with new result
                  updateQuery: (previousResult, { fetchMoreResult }) => {
                    let newData;
                    if (hitlFilters.correctionsFilter.value === ReviewTypeEnum.Corrections) {
                      newData = fetchMoreResult.reviewedUrlsListPaginated;
                    } 
                    // else if (
                    //   hitlFilters.correctionsFilter.value === ReviewTypeEnum.Predictions
                    // ) {
                    //   newData = fetchMoreResult.predictiveCorrectionsListPaginated;
                    // }
                    onCompletionPredictionsCorrections(newData, "UPDATE");
                  },
                }),
                hitlFilters.setUrlLimit((prev) => prev + 15);
              } else if (hitlFilters.correctionsFilter.value === ReviewTypeEnum.All) {
                fetchMore({
                  variables: {
                    publisher: hitlFilters.publisherFilter.value,
                    first: 15,
                    offset: hitlFilters.urlList.length,
                    search: hitlFilters.urlSearch,
                    category:
                      hitlFilters.categoryFilter.value === ReviewTypeEnum.All
                        ? ""
                        : hitlFilters.categoryFilter.value,
                  },
                  // updates previous result with new result
                  updateQuery: (previousResult, { fetchMoreResult }) => {
                    onCompletionAll(fetchMoreResult.urlList, "UPDATE");
                  },
                }),
                hitlFilters.setUrlLimit((prev) => prev + 15);
              }
            }}
            variant={"blueButton"}
          >
            Load more URLs...
          </Button>
        )}
      </Center>
    </>
  );
};

// more urls button is disabled when there are no more urls in redis cache (cursor = 0)
// & when there are no more pages (for corrections and predictions filters)
// const isMoreUrlsButtonDisabledFunction = (hitlFilters: IHITLFilters) => {
//   if (hitlFilters.correctionsFilter.value !== "ALL" && hitlFilters.endOfPages) {
//     return true;
//   } else if (
//     hitlFilters.cursor === 0 &&
//     hitlFilters.correctionsFilter.value === "ALL" &&
//     hitlFilters.urlLimit >= hitlFilters.urlList.length
//   ) {
//     return true;
//   } else {
//     return false;
//   }
// };

// used to trigger a refresh from the redis cache when required
// const isEndOfRedisCache = (hitlFilters: IHITLFilters) => {
//   if (
//     hitlFilters.urlLimit >= hitlFilters.urlList.length &&
//     hitlFilters.correctionsFilter.value === "ALL"
//   ) {
//     hitlFilters.setUrlLimit(hitlFilters.urlList.length);
//     return true;
//   }
// };

// OLD METHOD
// // rest api requires re querying of cache
// if (isEndOfRedisCache(hitlFilters)) {
//   // use load more urls to get next set from the redis cache
//   fetchMore({
//     variables: {
//       search: hitlFilters.urlSearch,
//       category:
//         hitlFilters.categoryFilter.value === "ALL"
//           ? ""
//           : hitlFilters.categoryFilter.value,
//       // cursor: hitlFilters.cursor,
//     },
//     // updates previous result with new result
//     updateQuery: (previousResult, { fetchMoreResult }) => {
//       onCompletionAll(fetchMoreResult.urlList, "UPDATE");
//     },
//   });
//   hitlFilters.setUrlLimit((prev) => prev + 15);
// } else {
//   hitlFilters.setUrlLimit((prev) => prev + 15);
//   setButtonLoading(false);
// }
